<template>
    <div class="container">
        <div class="form-group">
            <label for="zones">Organización: </label>
            <select class="form-control" id="zones" @change="fetchZones">
                <option value="">Seleccionar organización</option>
                <option v-for="city in cities" :key="city.id" :value="city.id">{{city.name}}</option>
            </select>
        </div>

        <div class="form-group" v-if="zones.length > 0">
            <label for="zones">Área: </label>
            <select class="form-control" id="zones" @change="fetchEntities">
                <option value="">Seleccionar área</option>
                <option v-for="zone in zones" :key="zone.id" :value="zone.id">{{zone.name}}</option>
            </select>
        </div>
        <div class="row">
            <div class="col-12">
                <input class="btn btn-primary" type="button" v-if="!add" value="Agregar nueva dependencia" @click="function(){add=true}">
                <div class="card" v-if="add">
                    <div class="card-header blue-gradient">Agrega una nueva dependencia</div>
                    <div class="card-body" id="form">
                        <form action="" @submit.prevent="storeEntity">
                            <div class="row">
                                <div class="form-group col-6">
                                    <label for="name">Nombre de la dependencia</label>
                                    <input required v-model="entity.name" type="text" class="form-control" placeholder="Nombre de la dependencia">
                                </div>
                                <div class="form-group col-6">
                                    <label for="name">NIT o Registro</label>
                                    <input v-model="entity.document" type="text" class="form-control" placeholder="NIT o Registro de la dependencia">
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-4">
                                    <label for="name">Teléfono</label>
                                    <input required v-model="entity.phone_number" type="number" class="form-control" placeholder="Teléfono de la dependencia">
                                </div>
                                <div class="form-group col-8">
                                    <label for="name">Domicilio</label>
                                    <textarea required v-model="entity.address" type="text" class="form-control" placeholder="Dirección de la dependencia" rows="4"></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-4">
                                    <label for="name">Usuario (correo): </label>
                                    <input required v-model="entity.email" type="text" class="form-control" placeholder="Email de inicio de sesión">
                                </div>
                                <div class="form-group col-4">
                                    <label for="name">Contraseña</label>
                                    <input required v-model="entity.password" type="password" class="form-control" placeholder="Digite la contraseña">
                                </div>
                                <div class="form-group col-4">
                                    <label for="name">Confirmar contraseña</label>
                                    <input required v-model="entity.password_confirmation" type="password" class="form-control" placeholder="Digite la contraseña">
                                </div>
                            </div>
                            <input class="btn btn-primary" type="submit" value="Guardar">
                        	<input class="btn btn-danger float-right" type="button" value="Cancelar" @click.prevent="function(){add=false}">
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row" v-if="entities.length > 0">
            <div class="col-12">
                <div class="card">
                    <div class="card-header green-gradient">Dependencias</div>
                    <div class="card-body table-responsive">
                        <table class="table table-stripped text-center" id="entities-table">
                            <thead>
                                <tr>
                                    <th>Dependencia</th>
                                    <th>Usuario</th>
                                    <th>Teléfono</th>
                                    <th>Áreas asignadas</th>
                                    <th>Dirección</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="entity in entities" :key="entity.id">
                                    <td>{{entity.name}}</td>
                                    <td>{{entity.email}}</td>
                                    <td>{{entity.phone_number}}</td>
                                    <td>
                                        <div v-for="entityZone in entity.zones.data" :key="entityZone.id"
                                            style="font-size: 14px; 
                                            white-space: pre-line; 
                                            padding: 5px; 
                                            margin-right: 2px;
                                            border-radius: 5px;
                                            border: 1px solid gray;
                                            background-color: lightblue">
                                            <span>{{entityZone.name}} - {{entityZone.city}}</span>
                                        </div>
                                    </td>
                                    <td>{{entity.address}}</td>
                                    <td>
                                        <a href="" class="btn btn-sm btn-info text-white" :data-entity-id="entity.id" @click.prevent="$router.push({name: 'edit-entity', params: {id: entity.id}})">
                                            <i class="fas fa-user-circle"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
function entity(){
    return {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        document: "",
        phone_number: "",
        address: "",
    }
}
export default {
    name: 'cities',
    mounted: function(){
        this.fetchCities();
    },
    data: () => ({
        baseUrl: process.env.VUE_APP_API,
        entities: [],
        zones: [],
        cities: [],
        entity: entity(),
        add: false,
        changePassword: false,
        selectedEntity: {id: 0, name: ""},
        table: null,
    }),
    methods: {
        openModal: function(e){
            this.changePassword = true;
            let entityId = e.currentTarget.getAttribute('data-entity-id');
            this.entityId = parseInt(entityId);
            
            let selectedEntity;
            for (let i = 0; i < this.entities.length; i ++) {
                if(this.entities[i].id == entityId){
                    selectedEntity = this.entities[i];
                    break;
                }
            }

            this.selectedEntity = selectedEntity;

        },
        fetchZones(e){
            const city_id = e.target.value;
            const url = `${this.$api}/public/cities/${city_id}/zones`;
            const loader = this.$loading.show();
            this.zones = [];
            this.entities = [];
            this.$http.get(url).then(response => {
                this.zones = response.body.data;
                loader.hide();
            }).catch(error => {
                loader.hide();
            })
        },
        fetchCities(){
            const url = `${this.$api}/public/cities`;
            const loader = this.$loading.show();
            this.$http.get(url).then(response => {
                this.cities = response.body.data;
                loader.hide();
            }).catch(error => {
                loader.hide();
            })
        },
        fetchEntities: function(event){
            const zone_id = event.target.value;
            let loader = this.$loading.show();
            this.entities = [];
            this.$http.get(`${this.baseUrl}/public/zones/${zone_id}/entities`)
            .then(data => {
                this.entities = data.body.data;
                loader.hide();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        storeEntity: function(){
            let loader = this.$loading.show();
            this.$http.post(`${this.baseUrl}/admin/entities`, this.entity)
            .then(data => {
                console.log(data);
                loader.hide();
                window.location.reload();
            })
            .catch(error => {
                let message = this.getMessages(error);
                loader.hide();
                this.$dialogs.alert(message, {title: 'Error', size: 'sm'});

            });
                
        },
        renderTable(table){
            if(this.table != null){
                this.table.destroy();
            }

            this.table = table.DataTable({
                destroy: true,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        },
        validateFields(){
            var $form = $("#form");
            var $fields = $form.find(".form-control");
            var valid = true;
            $fields.each(function(i, field){
                var $field = $(field);
                if($field.val() == ""){
                    valid = false;
                }
            });
            
            return valid;
        },
        getMessages(error){
            let errors = error.body;
            var message = "";
            for(var item in errors){
                for(var error in errors[item]){
                    message+=`${errors[item][error]}\n\n`;
                };
            }
            message+=""

            return message;
        }
    }

}
</script>
<style lang="scss" scoped>
    @import '../../assets/scss/colors';
    .container {
        position: relative;
    }
    .show {
        position: fixed;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -50%);
        background-color: white;
        box-shadow: 0px 0px 10px gray;   
        z-index: 3;
    }
    .show_container {
        background-color: rgba(0, 0, 0, 0.5);
        filter: blur();
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 2;
    }
</style>


